import { UserLoginState } from "../reducers/LoginReducer";
import { Common } from "./Common"
import {AppApprovalPoints} from "../constants/AppConstants"

export const Role = {
    appRequestor: {code:1, name:'Requestor' },
    appVendor: {code:2, name:'Vendor' },
    appSbuHoD: {code:9, name:'SBU HoD' },
    appExco: {code:3, name:'Ex Co' },
    appSBUFinance: {code:4, name:'SBU Finance' },
    appLegatoTM1: {code:6, name:'Legato TM1' },
    appLegatoTM2: {code:7, name:'Legato TM 2' },
    appLegatoTMLead: {code:8, name:'Legato Team Lead' },
    appSBUFinaceHead: {code:9, name:'SBU Finance Head' }
}

function isCurrentUserRole(rolecode:number){
    const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);
    if(user && user.userCompanies) {
        let userCompany = user.userCompanies.find((uc) => {
            if(uc.roleIds){
                for (let index = 0; index < uc.roleIds.length; index++) {
                    const roleId = uc.roleIds[index];
                    if(roleId == rolecode ){
                        return true;
                    }
                }
            }
            return false
        });
        return userCompany ? true : false;
    }
    return false;

}

function isRequestor(){
    return isCurrentUserRole(Role.appRequestor.code);
}

// function isVendor() {
//     return isCurrentUserRole(Role.appVendor.code);
// }

function isSbuHoD(){
    return isCurrentUserRole(Role.appSbuHoD.code);
}

function isSBUFinance() {
    return isCurrentUserRole(Role.appSBUFinance.code);
}

function isLegatoTeamMember(){
    if(isCurrentUserRole(Role.appLegatoTM1.code) || isCurrentUserRole(Role.appLegatoTM2.code)){
        return true;
    }
    return false;
}

function hasAuthVendorApprove(loginUserDetails:UserLoginState) {
    let isPermissons = false;
    //TODO 
    isPermissons = true;
    // if (loginUserDetails.roles && loginUserDetails.roles.length > 0) {
    //     for (let index = 0; index < loginUserDetails.roles.length; index++) {
    //       if (
    //         loginUserDetails.roles[index] == Role.appExco.code ||
    //         loginUserDetails.roles[index] == Role.appSBUFinance.code
    //       ) {
    //         isPermissons = true;
    //       }
    //     }
    //   }
    return isPermissons;
}

export const RoleUtil = {
    //isVendor,
    isSBUFinance,
    isRequestor,
    hasAuthVendorApprove
}